import Route from '@ember/routing/route';

export default class ProgramsProgramCohortMessagesRoute extends Route {}
